import RocketlaneLogo from 'module/ui/assets/svgs/rocketlane_icon_standard.svg';
import SalesforceLogo from 'module/ui/assets/svgs/salesforce-logo.svg';
import { Avatar } from '@rocketlane/ui';
import { FormattedMessage } from 'react-intl';
import { tv } from 'tailwind-variants';

const resourceHeaderVariants = tv({
  slots: {
    container: 'flex w-full',
    cell: 'flex items-center py-2 pt-4',
    text: 'font-semibold text-[12px] leading-[18px] text-[#6f6f6f] tracking-[0.16px]',
    iconContainer: 'flex items-center gap-2',
  },
  variants: {
    cellType: {
      main: {
        cell: 'h-[40px] px-2',
      },
      sync: {
        cell: 'h-[40px] px-0',
      },
      actions: {
        cell: 'h-[40px] justify-center px-2',
      },
    },
  },
});

export const ResourceHeader = () => {
  const { container, cell, text, iconContainer } = resourceHeaderVariants();

  return (
    <div className={container()}>
      <div className={cell({ cellType: 'main' })} style={{ flex: 1 }}>
        <div className={iconContainer()}>
          <Avatar src={SalesforceLogo} shape="square" size={20} />
          <span className={text()}>
            <FormattedMessage id="settings.integrations.sf.title" />
          </span>
        </div>
      </div>

      <div className={cell({ cellType: 'sync' })} style={{ width: '32px' }}>
        {/* Sync column spacer */}
      </div>

      <div className={cell({ cellType: 'main' })} style={{ flex: 1 }}>
        <div className={iconContainer()}>
          <Avatar src={RocketlaneLogo} shape="square" size={20} />
          <span className={text()}>
            <FormattedMessage id="rocketlane" />
          </span>
        </div>
      </div>

      <div className={cell({ cellType: 'actions' })} style={{ flex: 1 }}>
        <span className={text()}></span>
      </div>
    </div>
  );
};
